import React, { useCallback, useRef } from 'react';
import { func, node, oneOf, string } from 'prop-types';

import urls from 'constants/urls';
import { filterSearchQuery } from 'utils/query-string-params';
import { preserveStubsUrl } from 'utils/general';

import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';
import { LoadableTrolleyPage } from 'components/App/loadableComponents';

const goToTrolleyDefaultPropOnClick = () => {};

const GoToTrolley = ({
  children,
  className = '',
  id = null,
  onClick = goToTrolleyDefaultPropOnClick,
  originComponent = null,
  title = 'Go to your shopping trolley',
}) => {
  const anchorProps = {
    'aria-label': title,
    className,
    id,
    onClick,
    title,
  };
  const componentPreloadRef = useRef(false);

  const preloadTrolleyPage = useCallback(() => {
    if (componentPreloadRef.current) {
      return;
    }

    componentPreloadRef.current = true;
    LoadableTrolleyPage.preload();
  }, []);

  const href = preserveStubsUrl(`${urls.trolleyPage}?${filterSearchQuery('featureflag')}`);

  return (
    <LinkAsButton
      {...anchorProps}
      data-testid="header-trolley-link"
      data-actiontype="redirect"
      data-origincomponent={originComponent}
      data-shortdescription="Goes to trolley details"
      theme="secondary"
      href={href}
      onMouseEnter={preloadTrolleyPage}
      width="fit"
    >
      {children}
    </LinkAsButton>
  );
};

GoToTrolley.propTypes = {
  children: node.isRequired,
  className: string,
  id: string,
  linkStyle: oneOf(['button', 'text']),
  originComponent: string,
  onClick: func,
  title: string,
};

export default GoToTrolley;
